import src from "IMAGE";
export default { src, width: 198, height: 118, blurWidth: 0, blurHeight: 0};
